// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benefit-form {
    min-width: 150px;
    max-width: 100%;
    width: 100%;
  }
  
  .title-full-width {
    width: 40%;
  }


.benefit-container {
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 5px;
  }
  
  .addBenefit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  
  .property-container {
    display: grid;
    align-items: center;
    margin-bottom: 10px;
  }

  .property-full-width {
    max-width: 60%;
  }
  
  .delete-property-btn {
    margin-left: 5px;
  }
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNhZnJhdHRpLXRyYXZlbC1wbGFuLWJlbmVmaXRzLWFkZC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksZ0JBQWdCO0lBQ2hCLGVBQWU7SUFDZixXQUFXO0VBQ2I7O0VBRUE7SUFDRSxVQUFVO0VBQ1o7OztBQUdGO0lBQ0ksbUJBQW1CO0lBQ25CLGFBQWE7SUFDYixrQkFBa0I7RUFDcEI7O0VBRUE7SUFDRSxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLDhCQUE4QjtJQUM5QixtQkFBbUI7RUFDckI7O0VBRUE7SUFDRSxhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLG1CQUFtQjtFQUNyQjs7RUFFQTtJQUNFLGNBQWM7RUFDaEI7O0VBRUE7SUFDRSxnQkFBZ0I7RUFDbEIiLCJmaWxlIjoic2FmcmF0dGktdHJhdmVsLXBsYW4tYmVuZWZpdHMtYWRkLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYmVuZWZpdC1mb3JtIHtcbiAgICBtaW4td2lkdGg6IDE1MHB4O1xuICAgIG1heC13aWR0aDogMTAwJTtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICBcbiAgLnRpdGxlLWZ1bGwtd2lkdGgge1xuICAgIHdpZHRoOiA0MCU7XG4gIH1cblxuXG4uYmVuZWZpdC1jb250YWluZXIge1xuICAgIG1hcmdpbi1ib3R0b206IDIwcHg7XG4gICAgcGFkZGluZzogMTBweDtcbiAgICBib3JkZXItcmFkaXVzOiA1cHg7XG4gIH1cbiAgXG4gIC5hZGRCZW5lZml0LWhlYWRlciB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICB9XG4gIFxuICAucHJvcGVydHktY29udGFpbmVyIHtcbiAgICBkaXNwbGF5OiBncmlkO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgfVxuXG4gIC5wcm9wZXJ0eS1mdWxsLXdpZHRoIHtcbiAgICBtYXgtd2lkdGg6IDYwJTtcbiAgfVxuICBcbiAgLmRlbGV0ZS1wcm9wZXJ0eS1idG4ge1xuICAgIG1hcmdpbi1sZWZ0OiA1cHg7XG4gIH0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/safratti-travel-plan-benefits-add/safratti-travel-plan-benefits-add.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;;AAGF;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF,45CAA45C","sourcesContent":[".benefit-form {\n    min-width: 150px;\n    max-width: 100%;\n    width: 100%;\n  }\n  \n  .title-full-width {\n    width: 40%;\n  }\n\n\n.benefit-container {\n    margin-bottom: 20px;\n    padding: 10px;\n    border-radius: 5px;\n  }\n  \n  .addBenefit-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n  }\n  \n  .property-container {\n    display: grid;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n\n  .property-full-width {\n    max-width: 60%;\n  }\n  \n  .delete-property-btn {\n    margin-left: 5px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
